<template>
  <q-header :modelValue="headerVisible" class="index-header">
    <q-toolbar class="row justify-between">
      <div class="col-4 row justify-start">

        <q-btn class="headerBtn" flat dense stack no-caps icon="fa-solid fa-house" label="Home" to="/"/>

        <q-btn class="headerBtn" flat dense stack no-caps icon="fa-solid fa-photo-film" label="Media"
               v-on:mouseleave="mediaMenuTouchLeave" @click="mediaMenuShow=true">
          <q-menu :model-value="mediaMenuShow"
                  v-on:mouseover="mediaMenuTouchOver" v-on:mouseleave="mediaMenuTouchLeave"
                  style="background-color:rgba(0,0,0,0);box-shadow:none;backdrop-filter: none"
                  transition-hide="fade" transition-duration="800" no-parent-event
                  self="top middle" :offset="[-100, 3]">
            <q-item>
              <q-card class="header-kit-card row q-pa-sm">

                <q-btn class="col-6 subHeaderBtn q-my-sm" flat dense stack no-caps
                       icon="fa-solid fa-book" label="Article备录" to="/article/list"/>
                <q-btn class="col-6 subHeaderBtn q-my-sm" flat dense stack no-caps
                       icon="fa-solid fa-book-bookmark" label="Essay题记" to="/essay/list"/>
                <q-btn class="col-6 subHeaderBtn q-my-sm" flat dense stack no-caps
                       icon="fa-solid fa-clapperboard" label="Video视频" to="/video/collection"/>
                <q-btn class="col-6 subHeaderBtn q-my-sm" flat dense stack no-caps
                       icon="fa-solid fa-headphones" label="Music音乐" @click="headerKitInDeveloping"/>
              </q-card>
            </q-item>
          </q-menu>
        </q-btn>

        <q-btn class="headerBtn" flat dense stack no-caps icon="fa-solid fa-toolbox" label="Kit"
               v-on:mouseleave="kitMenuTouchLeave" @click="kitMenuShow=true">
          <q-menu :model-value="kitMenuShow"
                  v-on:mouseover="kitMenuTouchOver" v-on:mouseleave="kitMenuTouchLeave"
                  style="background-color:rgba(0,0,0,0);box-shadow:none;backdrop-filter: none"
                  transition-hide="fade" transition-duration="800" no-parent-event
                  self="top middle" :offset="[-100, 3]">
            <q-item>
              <q-card class="header-kit-card row q-pa-sm">

                <q-btn class="col-6 subHeaderBtn q-my-sm" flat dense stack no-caps
                       icon="fa-brands fa-square-steam" label="Steam游戏查询" to="/tools/steam/search"/>
                <q-btn class="col-6 subHeaderBtn q-my-sm" flat dense stack no-caps
                       icon="fa-solid fa-object-group" label="SQL生成Kotlin类" to="/tools/code/sql2kotlin"/>
                <q-btn class="col-6 subHeaderBtn q-my-sm" flat dense stack no-caps
                       icon="fa-solid fa-clock-rotate-left" label="时间戳格式转换" to="/tools/timestamp"/>
                <q-btn class="col-6 subHeaderBtn q-my-sm" flat dense stack no-caps
                       icon="fa-solid fa-qrcode" label="QR二维码生成" to="/tools/qrcode"/>
                <q-btn class="col-6 subHeaderBtn q-my-sm" flat dense stack no-caps
                       icon="fa-solid fa-location-pin-lock" label="Md5加密" to="/tools/md5"/>
                <q-btn class="col-6 subHeaderBtn q-my-sm" flat dense stack no-caps
                       icon="fa-solid fa-camera-rotate" label="Base64图片转换" to="/tools/imgBase64"/>
                <q-btn class="col-6 subHeaderBtn q-my-sm" flat dense stack no-caps
                       icon="fa-solid fa-envelope-open-text" label="Markdown转换" to="/tools/mkHtmlPdf"/>
                <q-btn class="col-6 subHeaderBtn q-my-sm" flat dense stack no-caps
                       icon="fa-solid fa-palette" label="RGB十六进制转换" to="/tools/rgbHex"/>
                <q-btn class="col-6 subHeaderBtn q-my-sm" flat dense stack no-caps
                       icon="fa-solid fa-id-card" label="身份证生成" to="/tools/cnIdCard"/>
                <q-btn class="col-6 subHeaderBtn q-my-sm" flat dense stack no-caps
                       icon="fa-solid fa-face-grin-tongue-wink" label="表情包电子包浆" @click="headerKitInDeveloping"/>
              </q-card>
            </q-item>
          </q-menu>
        </q-btn>


        <q-btn class="headerBtn" flat dense stack no-caps icon="fa-solid fa-clipboard"
               label="Board" to="/board"/>

      </div>
      <div class="col-4 row justify-center">
        <q-btn class="q-mr-md" flat  href="https://www.astercasc.com">
          <div class="row items-center justify-center">
            <div class="q-mr-sm" style="font-size: 14px">
              当前为旧版页面，点击此处前往新版本页面
            </div>
            <q-icon name="fa-solid fa-arrow-right-to-bracket" size="15px"/>
          </div>
        </q-btn>
      </div>
      <div class="col-4 row justify-end">
        <LoginUserAvatar/>
      </div>

    </q-toolbar>
  </q-header>
</template>

<script setup>
import LoginUserAvatar from "@/components/LoginUserAvatar.vue";
import {defineProps, ref} from "vue";
import {delay} from "@/utils/delay-exe";
import {useQuasar} from "quasar";

//notify
const notify = useQuasar().notify

defineProps({
  headerVisible: {
    type: Boolean,
    default: false
  }
})


//user menu
let onKitZone = ref(false)
let kitMenuShow = ref(false)
let onMediaZone = ref(false)
let mediaMenuShow = ref(false)


//感知菜单鼠标进入事件
function kitMenuTouchOver() {
  if (!mediaMenuShow.value) {
    onKitZone.value = true
    kitMenuShow.value = onKitZone.value
  }
}

function mediaMenuTouchOver() {
  if (!kitMenuShow.value) {
    onMediaZone.value = true
    mediaMenuShow.value = onMediaZone.value
  }
}

//感知菜单鼠标离开事件
function kitMenuTouchLeave() {
  onKitZone.value = false
  delay(300).then(() => {
    kitMenuShow.value = onKitZone.value
  })
}

function mediaMenuTouchLeave() {
  onMediaZone.value = false
  delay(300).then(() => {
    mediaMenuShow.value = onMediaZone.value
  })
}

//功能正在开发中
function headerKitInDeveloping() {
  notify({
    color: "cyan-9",
    message: "该功能正在开发中...",
    position: 'top-left',
    type: 'info',
    timeout: 2000
  })
}


</script>

<style lang="sass" scoped>
@import "@/styles/cask.sass"
@import "@/styles/cask-dialog-style.scss"
@import "@/styles/cask-primary-style.scss"
@import "@/styles/cask-little-mini-style.scss"


.header-kit-card
  color: $cask_base_black
  background-color: rgba(255, 255, 255, 0.8)
  //box-shadow: inset 0 0 1px 1px rgba(254, 254, 254, 0.9), 0 20px 27px 0 rgba(0, 0, 0, 0.05)
  backdrop-filter: saturate(200%) blur(30px)
  border-radius: 1rem

  font-family: Roboto Slab, sans-serif
  line-height: 1.625
  margin: 5%
  width: 300px
  min-height: 150px


</style>